<template>
  <div class="body-user">
    <!-- <vs-popup
      v-if="displayData"
      :title="$t('MY_ACCOUNT').Title"
      :active.sync="displayPopupMyAccount"
      class="my-account-modal"
    >
      <my-account></my-account>
    </vs-popup>
    <vs-popup
      v-if="displayData"
      :title="$t('USER_SIGNATURE').Title"
      :active.sync="displayPopupSignatures"
      class="user-signatures-modal"
    >
      <user-signatures></user-signatures>
    </vs-popup>
    <vs-popup
      v-if="displayData"
      :title="$t('USER_NOTIFICATION').Notification"
      :active.sync="displayPopupNotification"
      class="user-notification-modal"
    >
      <user-notification></user-notification>
    </vs-popup>
    <vs-popup
      v-if="displayData"
      :title="$t('CHANGE_PASSWORD').Title"
      :active.sync="displayPopupChangePassword"
      class="change-password-modal"
      id="change-pass"
    >
      <change-password></change-password>
    </vs-popup> -->
    <!-- <vs-popup
      v-if="displayData"
      title
      :active.sync="displayPopupPrivacyPolicy"
      class="privacy-policy-modal"
    >
      <privacy-policy></privacy-policy>
    </vs-popup> -->

    <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer dropdown-user users-login flex" :key="dropdownKey">
      <div class="w-full left" v-if="reduce">
        <!-- <div class="login-btn mb-1">{{ user_displayName }}</div> -->
        <!-- <div class="config-btn" @click.stop="$emit('open-my-account')"> <a href="#"> Minha Conta </a></div> -->
        <!-- <vs-avatar :text="getUserName" class="avatar mt-3"></vs-avatar> -->
        <!-- <vs-button :color="colorx" vscode-file://vscode-app/c:/Users/mmilanesitec.mayara/AppData/Local/Programs/Microsoft%20VS%20Code/resources/app/out/vs/code/electron-sandbox/workbench/workbench.html:gradient-color-secondary="colorx2" type="gradient" icon-pack="feather" icon="icon-user" @click.stop="$emit('open-my-account')" class="w-full left">{{ user_displayName }} <i class="feather icon-chevron-down" /></vs-button> -->
        <vs-button color="primary" type="flat" icon-pack="feather" icon="icon-user" style="margin:auto"></vs-button>
      </div>
      <div class="w-full left" v-if="!reduce">
        <!-- <div class="login-btn mb-1">{{ user_displayName }}</div> -->
        <!-- <div class="config-btn" @click.stop="$emit('open-my-account')"> <a href="#"> Minha Conta </a></div> -->
        <!-- <vs-avatar :text="getUserName" class="avatar mt-3"></vs-avatar> -->
        <vs-button v-if="isAuthenticated" :color="colorx" :gradient-color-secondary="colorx2" type="gradient" icon-pack="feather" icon="icon-user" @click.stop="$emit('open-my-account')" class="w-full left">{{ user_displayName }} <i class="feather icon-chevron-down" /></vs-button>
        <vs-button v-if="!isAuthenticated" :color="colorx" :gradient-color-secondary="colorx2" type="gradient" icon-pack="feather" icon="icon-user" @click.stop="$emit('open-my-account')" class="w-full left">{{ $t('BUTTONS').AccessAccount }} <i class="feather icon-chevron-down" /></vs-button>
        <!-- <vs-button color="primary" type="border" icon-pack="feather" icon="icon-user" ></vs-button> -->
      </div>
      <!-- <feather-icon icon="UserIcon" svgClasses="w-4 h-4" class="icon-user-profile"></feather-icon>
      <div
        v-if="!verticalNavMenuItemsMin"
        class="leading-tight sm:block"
        :class="{'menu-username-menu-reduce': reduce}"
      >
        <p class="font-semibold">{{ user_displayName }}</p>
      </div> -->
        <!-- <small>Available</small> -->
      <!-- <feather-icon icon="ChevronDownIcon" class="icon-chevron user-icon-chevron" svgClasses="h-4 w-4 ml-1" /> -->
      <vs-dropdown-menu
        class="vx-navbar-dropdown nav-dropdown-user"
        :class="{'dropdown-user-menu-reduced': verticalNavMenuItemsMin}"
        id="header-dropdown-menu-user"
      >
        <ul style="min-width: 9rem">
          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click.stop="openLogin"
            v-if="!isAuthenticated"
          >
            <feather-icon icon="UserIcon" svgClasses="w-4 h-4" class="icons-sub-menu"></feather-icon>
            <span class="ml-2">{{$t('BUTTONS').Enter}}</span>
          </li>
          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click.stop="openRegister"
            v-if="!isAuthenticated"
          >
            <feather-icon icon="UserIcon" svgClasses="w-4 h-4" class="icons-sub-menu"></feather-icon>
            <span class="ml-2">{{$t('BUTTONS').Register}}</span>
          </li>
          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click.stop="openMyAccount"
            v-if="isAuthenticated"
          >
            <feather-icon icon="UserIcon" svgClasses="w-4 h-4" class="icons-sub-menu"></feather-icon>
            <span class="ml-2">{{$t('NAVBAR_DROPDOWN_MENU').Profile}}</span>
          </li>
          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click.stop="openPlans"
            v-if="!isAuthenticated"
          >
            <feather-icon icon="UserIcon" svgClasses="w-4 h-4" class="icons-sub-menu"></feather-icon>
            <span class="ml-2">{{$t('NAVBAR_DROPDOWN_MENU').Packages}}</span>
          </li>
         <!-- <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="$emit('open-signature')"
            v-if="isAuthenticated"
          >
            <feather-icon icon="ShoppingBagIcon" svgClasses="w-4 h-4" class="icons-sub-menu"></feather-icon>
            <span class="ml-2">{{$t('NAVBAR_DROPDOWN_MENU').Signatures}}</span>
          </li>-->
          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click.stop="openNotification"
            v-if="isAuthenticated"
          >
            <feather-icon icon="BellIcon" svgClasses="w-4 h-4" class="icons-sub-menu"></feather-icon>
            <span class="ml-2">{{$t('NAVBAR_DROPDOWN_MENU').Notification}}</span>
          </li>
          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="openChangePassword"
            v-if="!s4Login && isAuthenticated"
          >
            <feather-icon icon="KeyIcon" svgClasses="w-4 h-4" class="icons-sub-menu"></feather-icon>
            <span class="ml-2">{{$t('NAVBAR_DROPDOWN_MENU').Change_Password}}</span>
          </li>
          <vs-divider></vs-divider>
          <!-- <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click.stop="displayPopupPrivacyPolicy= !displayPopupPrivacyPolicy"
          >
            <feather-icon icon="KeyIcon" svgClasses="w-4 h-4" class="icons-sub-menu"></feather-icon>
            <span class="ml-2">{{$t('NAVBAR_DROPDOWN_MENU').Privacy_Policy}}</span>
          </li> -->
          <!-- <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click.stop="$emit('open-help')"
          >
            <feather-icon icon="InfoIcon" svgClasses="w-4 h-4" class="icons-sub-menu"></feather-icon>
            <span class="ml-2">{{$t('NAVBAR_DROPDOWN_MENU').Help}}</span>
          </li> -->
          
          <!-- <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white" @click="$emit('change-theme')">
            <vs-switch v-model="themeMode" vs-value="dark" @click.prevent=""/>
            <span class="ml-2">{{currentTheme}}</span>
          </li> -->
          <!-- <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white" @click="changeThemeMode">
            <vs-switch v-model="themeMode" vs-value="dark" @click.prevent=""/>
            <span class="ml-2">{{currentTheme}}</span>
          </li> -->
          
          <!-- PLATFORM ZOOM -->
           <li class="py-2 px-4 cursor-pointer">
            <div class="flex">
              <feather-icon icon="SlidersIcon" svgClasses="w-4 h-4" class="icons-sub-menu"></feather-icon>
              <span class="ml-2">Zoom</span>
            </div>
            <div class="flex">
              <vs-button
              color="primary"
              type="line"
              @click.stop="updateZoom80"
              :class="{'selected': isPlatformZoomUltraCompact}"
              >80%</vs-button>
              <vs-button
              color="primary"
              type="line"
              @click.stop="updateZoom90"
              :class="{'selected': isPlatformZoomCompact}"
              >90%</vs-button>
              <vs-button
              color="primary"
              type="line"
              @click.stop="updateZoom100"
              :class="{'selected': (isPlatformZoomDefault || !currentPlatformZoom)}"
              >100%</vs-button>
              <vs-button
              color="primary"
              type="line"
              @click.stop="updateZoom110"
              :class="{'selected': isPlatformZoomBig}"
              >110%</vs-button>
            </div>
          </li>
          <!-- TAMANHO DO TEXTO -->
           <li class="py-2 px-4 cursor-pointer">
            <div class="flex">
              <feather-icon icon="SlidersIcon" svgClasses="w-4 h-4" class="icons-sub-menu"></feather-icon>
              <span class="ml-2">{{$t('NAVBAR_DROPDOWN_MENU').Font_Size}}</span>
            </div>
            <div class="flex">
              <vs-button
              color="primary"
              type="line"
              @click.stop="$emit('update-zoom-compact')"
              :class="{'selected': isZoomCompact}"
              >A-</vs-button>
              <vs-button
              color="primary"
              type="line"
              @click.stop="$emit('update-zoom-default')"
              :class="{'selected': isZoomDefault}"
              >Normal</vs-button>
              <vs-button
              color="primary"
              type="line"
              @click.stop="$emit('update-zoom-big')"
              :class="{'selected': isZoomBig}"
              >A+</vs-button>
            </div>
          </li>
          <li class="py-2 px-4 cursor-pointer">
            <div class="flex">
              <feather-icon icon="SlidersIcon" svgClasses="w-4 h-4" class="icons-sub-menu"></feather-icon>
              <span class="ml-2">{{$t('NAVBAR_DROPDOWN_MENU').Font_Align}}</span>
            </div>
            <div class="flex">
              <vs-button
                color="primary"
                type="line"
                @click.stop="$emit('update-format-align-left')"
                icon-pack="feather"
                icon="icon-align-left"
                class="w-full"
                :class="{'selected': isFormatAlignLeft}"
                ></vs-button                    >
                <vs-button
                color="primary"
                type="line"
                icon-pack="feather"
                icon="icon-align-center"
                @click.stop="$emit('update-format-align-center')"
                class="w-full"
                :class="{'selected': isFormatAlignCenter}"
                ></vs-button>
                <vs-button
                color="primary"
                type="line"
                @click.stop="$emit('update-format-align-right')"
                icon-pack="feather"
                icon="icon-align-right"
                class="w-full"
                :class="{'selected': isFormatAlignRight}"
                ></vs-button>
            </div>
          </li>
          <!-- <li class="py-2 px-4 cursor-pointer">
            <div class="flex">
              <feather-icon icon="LayoutIcon" svgClasses="w-4 h-4" class="icons-sub-menu"></feather-icon>
              <span class="ml-2">{{$t('NAVBAR_DROPDOWN_MENU').Appearance}}</span>
            </div>
            <div class="view-mode user flex">
              <span
                class="icons-tools-wrap icons-tools-wrap-mobile btn-left"
                :class="{ 'menu-btn-item-selected': isListView }"
                @click.stop="listView"
              >
                Lista
              </span>
              <span
                class="icons-tools-wrap icons-tools-wrap-mobile btn-right"
                :class="{ 'menu-btn-item-selected': isListViewDetailed }"
                @click.stop="listViewDetailed"
              >
                Cards
              </span>
              <span
                class="icons-tools-wrap icons-tools-wrap-mobile btn-right"
                :class="{ 'menu-btn-item-selected': isListViewCard }"
                @click.stop="listViewCard"
              >
                Mosaico
              </span>
            </div>
          </li> -->

          <li
            class="flex py-2 px-4 cursor-pointer"
            @click.stop="$emit('change-theme')"
            style="justify-content: space-between; align-items: center;"
          >
            <div class="flex">
              <feather-icon :icon="iconCurrentTheme" svgClasses="w-4 h-4" class="icons-sub-menu"></feather-icon>
              <span class="ml-2">{{currentTheme}}</span>
            </div>
            <vs-switch
              class=""
              v-model="themeMode"
              vs-value="dark"
              aria-setsize="small"
              @click.prevent=""
            />
          </li>

          <li
            class="flex py-2 px-4 cursor-pointer"
            @click.stop="$emit('changeDisplayTicker')"
            v-if="isAuthenticated && !isProfileFree"
            style="justify-content: space-between;align-items: center;"
          >
            <div class="flex">
              <feather-icon :icon="iconShowTicker" svgClasses="w-4 h-4" class="icons-sub-menu"></feather-icon>
              <span class="ml-2">{{showTicker}}</span>
            </div>
            <vs-switch
              class=""
              v-model="canDisplayTicker"
              aria-setsize="small"
              @click.prevent=""
            />
          </li>

          <li>
            <vx-tooltip :text="$t('MY_ACCOUNT').Text_Language" position="right" delay=".2s" class="flex py-2 px-4 cursor-pointer">
              <feather-icon icon="GlobeIcon" svgClasses="w-4 h-4" class="icons-sub-menu"></feather-icon>
              <span class="ml-2">{{ $t("NAVBAR_DROPDOWN_MENU").Language }}</span>
              <flags class="flagsview"></flags>
            </vx-tooltip>
          </li>

          <vs-divider></vs-divider>

          <!-- <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="$emit('open-privacy-policy')"
          >
            <feather-icon icon="ShieldIcon" svgClasses="w-4 h-4" class="icons-sub-menu"></feather-icon>
            <span class="ml-2">{{$t('NAVBAR_DROPDOWN_MENU').Privacy_Policy}}</span>
          </li> -->
          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="$emit('open-attendance') && closeDropdown()"
          >
            <feather-icon icon="HelpCircleIcon" svgClasses="w-4 h-4" class="icons-sub-menu"></feather-icon>
            <span class="ml-2">{{$t('NAVBAR_DROPDOWN_MENU').Help}}</span>
          </li>
          <li
            v-if="isAuthenticated"
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="$emit('open-quotes-config') && closeDropdown()"
          >
            <feather-icon icon="SettingsIcon" svgClasses="w-4 h-4" class="icons-sub-menu"></feather-icon>
            <span class="ml-2">{{$t('NAVBAR_DROPDOWN_MENU').Quotes_Config}}</span>
          </li>
          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="$emit('open-help') && closeDropdown()"
          >
            <feather-icon icon="GlobeIcon" svgClasses="w-4 h-4" class="icons-sub-menu"></feather-icon>
            <span class="ml-2">{{$t('NAVBAR_DROPDOWN_MENU').About}}</span>
          </li>
          <vs-divider v-if="!s4Login && isAuthenticated"></vs-divider>
          <li 
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click.stop="$emit('logout')"
            v-if="!s4Login && isAuthenticated"
          >
            <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4" class="icons-sub-menu"></feather-icon>
            <span class="ml-2">{{ $t("NAVBAR_DROPDOWN_MENU").Logout }}</span>
          </li>
        </ul>
      </vs-dropdown-menu>
    </vs-dropdown>
    
  </div>
</template>

<script>
import AppConstants from "../../appConstants";
import Flags from "../../components/translate/Flags.vue";
import localStorageHelper from "../../helpers/local-storage-helper";
import layoutService from "../../providers/layoutService";
import ChangePassword from "./ChangePassword.vue";
import MyAccount from "./MyAccount.vue";
import UserSignatures from "./UserSignatures.vue";
import UserNotification from "./UserNotification.vue";
import PrivacyPolicy from "./help/PrivacyPolicy.vue";
import ChangeZoom from "../../plugins/ChangeZoom";
import { EventBus } from "../../event-bus";


export default {
  props: {
    displayData: Boolean,
    verticalNavMenuItemsMin: Boolean,
    reduce: Boolean,
    user_displayName: String
  },
  data() {
    return {
      dropdownKey: 0,
      displayPopupMyAccount: false,
      displayPopupChangePassword: false,
      displayPopupChangeFont: false,
      displayPopupSignatures: false,
      displayPopupNotification: false,
      displayPopupPrivacyPolicy: false,
      colorx: '#00663b',
      colorx2: '#afca0d',
    };
  },
  watch: {},
  computed: {
    userProfile() {
      return this.$store.state.AppActiveUser.profile;
    },
    isProfileFree() {
      return this.userProfile == AppConstants.USER_PROFILE.FREE;
    },
    canDisplayTicker() {
      return this.$store.state.canDisplayTicker;
    },
    s4Login() {
      return localStorageHelper.getS4Login();
    },
    isDesktop() {
      return this.$store.state.isDesktop;
    },
    iconShowTicker() {
      if (this.canDisplayTicker == false) {
        return "EyeIcon";
      }
      return "EyeOffIcon";
    },
    iconCurrentTheme() {
      if (this.$store.state.theme === AppConstants.THEME.DARK) {
        return "SunIcon";
      }
      return "MoonIcon";
    },
    isAuthenticated() {
      return this.$store.state.isAuthenticated;
    },
    themeMode() {
      return this.$store.state.theme === AppConstants.THEME.DARK;
    },
    showTicker() {
      if (this.canDisplayTicker === false) {
        return this.$t("NAVBAR_DROPDOWN_MENU").Show_Ticker;
      }
      return this.$t("NAVBAR_DROPDOWN_MENU").Hide_Ticker;
    },
    currentTheme() {
      if (this.$store.state.theme === AppConstants.THEME.DARK) {
        return this.$t("NAVBAR_DROPDOWN_MENU").Light_Theme;
      }
      return this.$t("NAVBAR_DROPDOWN_MENU").Dark_Theme;
    },
    activeUserInfo() {
      return this.$store.state.AppActiveUser;
    },
    isListView() {
      return (
        this.$store.state.reportViewStyle ===
        AppConstants.REPORT_VIEW_STYLE.LISTVIEW
      );
    },
    isListViewDetailed() {
      return (
        this.$store.state.reportViewStyle ===
        AppConstants.REPORT_VIEW_STYLE.LISTVIEW_DETAILED
      );
    },
    isListViewCard() {
      return (
        this.$store.state.reportViewStyle ===
        AppConstants.REPORT_VIEW_STYLE.CARDVIEW
      );
    },
    currentZoomDetail() {
      return this.activeUserInfo.zoomDetail;
    },
    currentPlatformZoom() {
      return this.activeUserInfo.zoom;
    },
    isPlatformZoomUltraCompact() {
        return this.currentPlatformZoom === '80%';
    },
    isPlatformZoomCompact() {
        return this.currentPlatformZoom === '90%';
    },
    isPlatformZoomDefault() {
        return this.currentPlatformZoom === '100%';
    },
    isPlatformZoomBig() {
        return this.currentPlatformZoom === '110%';
    },
    isPlatformZoomUltraBig() {
        return this.currentPlatformZoom === '120%';
    },
    isZoomCompact() {
        return this.currentZoomDetail === AppConstants.ZOOM.COMPACT;
    },
    isZoomDefault() {
        return this.currentZoomDetail === AppConstants.ZOOM.DEFAULT;
    },
    isZoomMedium() {
        return this.currentZoomDetail === AppConstants.ZOOM.MEDIUM;
    },
    isZoomBig() {
        return this.currentZoomDetail === AppConstants.ZOOM.BIG;
    },
    getUserName() {
      if (!this.activeUserInfo.nome) {
        return '';
      }
      const split = this.activeUserInfo.nome.split(' ');
      return `${split[0]} ${split[split.length - 1]}`;
    },
    currentFormatAlignDetail() {
      return this.activeUserInfo.formatAlignDetail;
    },
    isFormatAlignLeft() {
      return (
        this.currentFormatAlignDetail === AppConstants.DETAIL_FORMAT_ALIGN.LEFT
      );
    },
    isFormatAlignCenter() {
      return (
        this.currentFormatAlignDetail ===
        AppConstants.DETAIL_FORMAT_ALIGN.CENTER
      );
    },
    isFormatAlignRight() {
      return (
        this.currentFormatAlignDetail === AppConstants.DETAIL_FORMAT_ALIGN.RIGHT
      );
    },
  },
  methods: {
    updateZoom80() {
      this.$emit('update-platform-zoom-ultra-compact')
      this.updateHighlights()
    },
    updateZoom90() {
      this.$emit('update-platform-zoom-compact')
      this.updateHighlights()
    },
    updateZoom100() {
      this.$emit('update-platform-zoom-default')
      this.updateHighlights()
    },
    updateZoom110() {
      this.$emit('update-platform-zoom-big')
      this.updateHighlights()
    },
    updateHighlights() {
      EventBus.$emit(AppConstants.BUS_EVENT_UPDATE_HIGHLIGHTS);
    },
    openChangePassword() {
      this.closeDropdown();
      this.$emit('open-change-password');
    },
    openNotification() {
      this.closeDropdown();
      this.$emit('open-notification');
    },
    openMyAccount() {
      this.closeDropdown();
      this.$emit('open-my-account');
    },
    openRegister() {
      this.closeDropdown();
      this.$emit('open-register');
    },
    openPlans() {
      this.closeDropdown();
      this.$emit('open-plans');
    },
    openLogin() {
      this.closeDropdown();
      this.$emit('open-login');
    },
    closeDropdown() {
      this.dropdownKey = Math.random();
    },
    updateZoomCompact() {
      ChangeZoom.setCompact();
    },
    updateZoomDefault() {
      ChangeZoom.setDefault();
    },
    updateZoomMedium() {
      ChangeZoom.setMedium();
    },
    updateZoomBig() {
      ChangeZoom.setBig();
    },
    listView() {
      this.$store.dispatch(
        "reportListStyle",
        AppConstants.REPORT_VIEW_STYLE.LISTVIEW
      );
      this.saveReportViewStyle(AppConstants.REPORT_VIEW_STYLE.LISTVIEW);
    },
    listViewDetailed() {
      this.$store.dispatch(
        "reportListStyle",
        AppConstants.REPORT_VIEW_STYLE.LISTVIEW_DETAILED
      );
      this.saveReportViewStyle(
        AppConstants.REPORT_VIEW_STYLE.LISTVIEW_DETAILED
      );
    },
    listViewCard() {
      this.$store.dispatch(
        "reportListStyle",
        AppConstants.REPORT_VIEW_STYLE.CARDVIEW
      );
      this.saveReportViewStyle(
        AppConstants.REPORT_VIEW_STYLE.CARDVIEW
      );
    },

    saveReportViewStyle(val) {
      localStorageHelper.updateReportViewStyle(val);

      const form = {
        viewstyle: val,
      };
      if (this.isAuthenticated) {
        layoutService.saveLayout(form, new URLSearchParams());
      }
    },
  },
  components: {
    MyAccount,
    Flags,
    ChangePassword,
    UserSignatures,
    UserNotification,
    PrivacyPolicy
  },
};
</script>

<style>
</style>